import { render, staticRenderFns } from "./gateOrder.vue?vue&type=template&id=f35f6072&scoped=true"
import script from "./gateOrder.vue?vue&type=script&lang=js"
export * from "./gateOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35f6072",
  null
  
)

export default component.exports